var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brush",
    clipPath: "url(#clip0_505_124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9707 2.25781H8.9707C3.9707 2.25781 1.9707 4.25781 1.9707 9.25781V15.2578C1.9707 20.2578 3.9707 22.2578 8.9707 22.2578H14.9707C19.9707 22.2578 21.9707 20.2578 21.9707 15.2578V13.2578",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.8795 3.81803C20.6495 6.88803 17.5595 11.068 14.9795 13.138L13.3995 14.398C13.1995 14.548 12.9995 14.668 12.7695 14.758C12.7695 14.608 12.7595 14.458 12.7395 14.298C12.6495 13.628 12.3495 12.998 11.8095 12.468C11.2595 11.918 10.5995 11.608 9.91945 11.518C9.75945 11.508 9.59945 11.498 9.43945 11.508C9.52945 11.258 9.65945 11.028 9.82945 10.838L11.0895 9.25803C13.1595 6.67803 17.3495 3.56803 20.4095 2.33803C20.8795 2.15803 21.3395 2.29803 21.6295 2.58803C21.9295 2.88803 22.0695 3.34803 21.8795 3.81803Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7801 14.7478C12.7801 15.6278 12.4401 16.4678 11.8101 17.1078C11.3201 17.5978 10.6601 17.9378 9.87009 18.0378L7.90009 18.2478C6.83009 18.3678 5.91009 17.4578 6.03009 16.3678L6.24009 14.3978C6.43009 12.6478 7.89009 11.5278 9.45009 11.4978C9.61009 11.4878 9.77009 11.4978 9.93009 11.5078C10.6101 11.5978 11.2701 11.9078 11.8201 12.4578C12.3601 12.9978 12.6601 13.6178 12.7501 14.2878C12.7701 14.4478 12.7801 14.6078 12.7801 14.7478Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.8193 12.2378C15.8193 10.1478 14.1293 8.44775 12.0293 8.44775",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_505_124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.257812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/Content.95c598496b737061933b7536ce6d3dcf.svg";
export { ForwardRef as ReactComponent };